export type LpuFeatureFlagKey =
  | 'has_pay_oms'
  | 'has_pay_dms'
  | 'has_pay_card'
  | 'has_pay_qr_code'
  | 'has_pay_sbp'
  | 'has_pay_cash'
  | 'has_parking'
  | 'h24'
  | 'has_bike_parking'
  | 'has_ambulance'
  | 'has_house_doctor'
  | 'has_children_area'
  | 'has_free_wifi'
  | 'has_drugstore'
  | 'has_day_hospital'
  | 'has_hospital'
  | 'has_analysis_collection'
  | 'has_ct'
  | 'has_mri'
  | 'has_ultrasound'
  | 'has_xray'
  | 'has_teeth_ct'
  | 'has_teeth_xray'
  | 'sick_leave'
  | 'certificate'

export type LpuFeaturePatientGroup = 'children' | 'adult' | 'adult_and_children'

export type LpuFeatureSpecialCondition =
  | 'vkhod-na-invalidnoj-kolyaske'
  | 'pandus'
  | 'knopka-vyzova-personala'
  | 'tualet-dlya-lyudej-s-invalidnostyu'
  | 'lift'

type FlagFeatureDefinition = {
  kind: 'flag'
  key: LpuFeatureFlagKey
  label: string
  iconSrc: string
}

type PatientFeatureDefinition = {
  kind: 'patient_group'
  key: LpuFeaturePatientGroup
  label: string
  iconSrc: string
}

type SpecialConditionFeatureDefinition = {
  kind: 'special_condition'
  key: LpuFeatureSpecialCondition
  label: string
  iconSrc: string
}

export type LpuFeatureDefinition =
  | FlagFeatureDefinition
  | PatientFeatureDefinition
  | SpecialConditionFeatureDefinition

/**
 * Порядок категорий и пунктов — как в django-templates/.../profile/info.html.
 */
export const LPU_FEATURE_DEFINITIONS: LpuFeatureDefinition[] = [
  // Оплата
  {
    kind: 'flag',
    key: 'has_pay_oms',
    label: 'ОМС',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/oms.svg',
  },
  {
    kind: 'flag',
    key: 'has_pay_dms',
    label: 'ДМС',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/dms.svg',
  },
  {
    kind: 'flag',
    key: 'has_pay_card',
    label: 'Карта',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/card.svg',
  },
  {
    kind: 'flag',
    key: 'has_pay_qr_code',
    label: 'QR-код',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/qr.svg',
  },
  {
    kind: 'flag',
    key: 'has_pay_sbp',
    label: 'СБП',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/sbp.svg',
  },
  {
    kind: 'flag',
    key: 'has_pay_cash',
    label: 'Наличные',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/cash.svg',
  },

  // Особенности
  {
    kind: 'flag',
    key: 'has_parking',
    label: 'Собственная парковка',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/parking.svg',
  },
  {
    kind: 'flag',
    key: 'h24',
    label: 'Работает круглосуточно',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/h24.svg',
  },
  {
    kind: 'flag',
    key: 'has_bike_parking',
    label: 'Велопарковка',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/bike-parking.svg',
  },
  {
    kind: 'flag',
    key: 'has_ambulance',
    label: 'Собственная скорая помощь',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/ambulance.svg',
  },
  {
    kind: 'flag',
    key: 'has_house_doctor',
    label: 'Вызов врача на дом',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/house-doctor.svg',
  },
  {
    kind: 'flag',
    key: 'has_children_area',
    label: 'Детская зона',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/children-area.svg',
  },
  {
    kind: 'flag',
    key: 'has_free_wifi',
    label: 'Бесплатный Wi-Fi',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/wifi.svg',
  },
  {
    kind: 'flag',
    key: 'has_drugstore',
    label: 'Аптека',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/pharmacy.svg',
  },

  // Пациенты
  {
    kind: 'patient_group',
    key: 'children',
    label: 'Только дети',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/patients-children.svg',
  },
  {
    kind: 'patient_group',
    key: 'adult',
    label: 'Только взрослые',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/patients-adult.svg',
  },
  {
    kind: 'patient_group',
    key: 'adult_and_children',
    label: 'Взрослые и дети',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/patients-adult-children.svg',
  },

  // Пребывание
  {
    kind: 'flag',
    key: 'has_day_hospital',
    label: 'Дневной стационар',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/day-hospital.svg',
  },
  {
    kind: 'flag',
    key: 'has_hospital',
    label: 'Стационар',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/hospital.svg',
  },

  // Специальные условия (порядок как в info.html)
  {
    kind: 'special_condition',
    key: 'vkhod-na-invalidnoj-kolyaske',
    label: 'Вход на инвалидной коляске',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/wheelchair-entrance.svg',
  },
  {
    kind: 'special_condition',
    key: 'pandus',
    label: 'Пандус',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/ramp.svg',
  },
  {
    kind: 'special_condition',
    key: 'knopka-vyzova-personala',
    label: 'Кнопка вызова персонала',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/call-button.svg',
  },
  {
    kind: 'special_condition',
    key: 'tualet-dlya-lyudej-s-invalidnostyu',
    label: 'Туалет для инвалидов',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/accessible-toilet.svg',
  },
  {
    kind: 'special_condition',
    key: 'lift',
    label: 'Лифт',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/elevator.svg',
  },

  // Обследования
  {
    kind: 'flag',
    key: 'has_analysis_collection',
    label: 'Пункт приёма анализов',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/analysis.svg',
  },
  {
    kind: 'flag',
    key: 'has_ct',
    label: 'КТ',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/ct.svg',
  },
  {
    kind: 'flag',
    key: 'has_mri',
    label: 'МРТ',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/mri.svg',
  },
  {
    kind: 'flag',
    key: 'has_ultrasound',
    label: 'УЗИ',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/ultrasound.svg',
  },
  {
    kind: 'flag',
    key: 'has_xray',
    label: 'Рентген',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/xray.svg',
  },
  {
    kind: 'flag',
    key: 'has_teeth_ct',
    label: 'КТ зубных рядов',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/teeth-ct.svg',
  },
  {
    kind: 'flag',
    key: 'has_teeth_xray',
    label: 'Рентген зубов',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/teeth-xray.svg',
  },

  // Медицинские справки
  {
    kind: 'flag',
    key: 'sick_leave',
    label: 'Больничный лист',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/sick-leave.svg',
  },
  {
    kind: 'flag',
    key: 'certificate',
    label: 'Медицинские справки',
    iconSrc: '/static/_v1/pd/icons/branding/lpu/features/certificate.svg',
  },
]

export type LpuFeatureKey = LpuFeatureDefinition['key']
